var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#2AA444"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9995 15.2063L24.5195 9.73301C24.177 9.47608 23.761 9.33588 23.3328 9.33301H8.66616C8.23798 9.33588 7.82203 9.47608 7.47949 9.73301L15.9995 15.2063Z",
    fill: "#F9F9F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3594 16.5598L16.246 16.6132H16.1927C16.1313 16.6406 16.0661 16.6586 15.9993 16.6665C15.944 16.6735 15.888 16.6735 15.8327 16.6665H15.7793L15.666 16.6132L6.73268 10.8398C6.69 11.0009 6.66761 11.1666 6.66602 11.3332V20.6665C6.66602 21.1969 6.87673 21.7057 7.2518 22.0807C7.62687 22.4558 8.13558 22.6665 8.66602 22.6665H23.3327C23.8631 22.6665 24.3718 22.4558 24.7469 22.0807C25.122 21.7057 25.3327 21.1969 25.3327 20.6665V11.3332C25.3311 11.1666 25.3087 11.0009 25.266 10.8398L16.3594 16.5598Z",
    fill: "#F9F9F9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.2f785f9e88d092e6eb13ce109acb0e30.svg";
export { ForwardRef as ReactComponent };